export default __webpack_public_path__ + "static/media/secureWhite.7b035c28.svg";